import Accordion from 'components/ui/ContentBlocks/Accordion';
import RichText from 'components/ui/ContentBlocks/RichText';
import { useTranslation } from 'hooks/useTranslation';
import ItineraryTimeline from 'components/ui/ContentBlocks/ItineraryTimeline';
import type { Accommodation } from 'types/Quote';
import type { ItineraryTimelineType } from 'components/ui/ContentBlocks/ItineraryTimeline';

type Props = {
  itineraryText: string | undefined;
  accommodation?: Accommodation;
};

const getItinerarySteps = (text?: string): ItineraryTimelineType[] => {
  const groups = text?.split(/#/g).filter(Boolean) || [];

  return groups.reduce((acc: ItineraryTimelineType[], val: string) => {
    const splittedGroups: string[] = val.split(/(.*?)\r?\n/gim).filter(Boolean);
    const steps = splittedGroups
      .map((step, index) => (index !== 0 ? step : ''))
      .filter(Boolean);
    acc.push({
      title: splittedGroups[0],
      steps,
    });

    return acc;
  }, []);
};

const Itinerary = ({ itineraryText, accommodation }: Props): JSX.Element => {
  const { t } = useTranslation();
  const itineraryWithSteps = getItinerarySteps(itineraryText);

  return (
    <div
      id="itinerary"
      className="px-5 md:px-4 pb-16 lg:pb-24 lg:grid md:grid-cols-3 md:mt-16 lg:mt-24"
    >
      <div>
        <h2 className="adelle-bold-section-headline">
          {t('doctorProfile.itinerary.title')}
        </h2>
      </div>
      <div className="col-span-2">
        <p className="mb-6">{t('doctorProfile.itinerary.description')}</p>
        <Accordion>
          {itineraryText && (
            <Accordion.Item
              title={t('doctorProfile.itinerary.itinerary')}
              transparent
            >
              <ItineraryTimeline itineraryWithSteps={itineraryWithSteps} />
            </Accordion.Item>
          )}
          {accommodation && (
            <Accordion.Item
              title={t('doctorProfile.itinerary.accommodation')}
              transparent
            >
              <h4 className="text-primary font-bold mb-2">
                {accommodation.name}
              </h4>
              <RichText fields={accommodation.about} />
              {/* {accommodation && (
                <div className="grid md:grid-cols-2 gap-4 mt-6">
                  {getFirstImages(accommodation).map((photo, index: number) => (
                    <Image
                      key={index}
                      src={photo.url}
                      alt={photo.description}
                      width={384}
                      height={280}
                      fit="fill"
                      contentful
                    />
                  ))}
                </div>
              )} */}
            </Accordion.Item>
          )}
        </Accordion>
      </div>
    </div>
  );
};

export default Itinerary;
